import type { AlarmIndicatorWidget } from '../../../widgets';
import {
  CheckboxField,
  OptionalBindingRow,
  Section,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Alarm-Anzeige. Entweder ein Punkt oder die ganze Anlage, beides zugleich
 *  ergibt keine sinnvolle Zahl. */
export function AlarmIndicatorEditor(
  { widget, plantId, onChange }: WidgetEditorProps<AlarmIndicatorWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Umfang">
        <CheckboxField
          label="Ganze Anlage zählen"
          checked={widget.scopedToPlant}
          hint="Eingeschaltet zählt die Anzeige jeden Alarm der Anlage, unabhängig vom Punkt unten."
          onChange={(next) => patch({ scopedToPlant: next })}
        />
        {!widget.scopedToPlant && (
          <OptionalBindingRow
            label="Datenpunkt"
            value={widget.pointFilter}
            plantId={plantId}
            hint="Leer lassen heißt: keine Einschränkung."
            onChange={(next) => patch({ pointFilter: next })}
          />
        )}
        <CheckboxField
          label="Anzahl anzeigen"
          checked={widget.showCount !== false}
          onChange={(next) => patch({ showCount: next })}
        />
      </Section>
    </>
  );
}
